import {Button} from '@luminopia/react-toolbox/lib/button'
import Form, {ITheme as IFormTheme} from 'core/components/form/Form'
import TextField, {ITextFieldProps, ITheme as ITextFieldTheme} from 'core/components/form/text-field'
import {createValidator, required, integer, email, npiValidator, minLength, match} from 'core/validation'
import * as React from 'react'
import {Field, FormProps, reduxForm, SubmitHandler} from 'redux-form'
import * as classNames from './RegisterForm.css'

export interface IFormFields {
  firstName: string
  lastName: string
  npi: string
  confirmNpi: string
  email: string
  password: string
}

interface ITheme extends IFormTheme {
  button?: string
  textFieldTheme?: ITextFieldTheme
}

interface IProps extends FormProps<IFormFields, {}, {}> {
  theme?: ITheme
}

const generatePassword = (): string => {
  const length = 12;
  let password = '';
  for (let i = 0; i < length; i++) {
    password += String.fromCharCode(Math.floor(Math.random() * 94) + 33);
  }
  return password;
};

/**
 * Registeration form intended for use with redux-form.
 */
class RegisterForm extends React.PureComponent<IProps, {}> {
  public render(): React.ReactElement<{}> {
    // const restictConfirmNpi = document.getElementById('confirmNpi')
    // if (restictConfirmNpi) {
    //   restictConfirmNpi.onpaste = e => {
    //     e.preventDefault()
    //     return false
    //   }
    // }

    const { handleSubmit, pristine, submitting, error, theme = {} } = this.props
    const firstNameProps: ITextFieldProps = {
      label: 'First Name',
      placeholder: 'First Name',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }
    const lastNameProps: ITextFieldProps = {
      label: 'Last Name',
      placeholder: 'Last Name',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }
    const npiProps: ITextFieldProps = {
      label: 'NPI',
      placeholder: 'NPI',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }
    const confirmNpiProps: ITextFieldProps = {
      label: 'Confirm NPI',
      placeholder: 'Confirm NPI',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }
    const emailProps: ITextFieldProps = {
      label: 'Email',
      placeholder: 'Email',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }
    const passwordProps: ITextFieldProps = {
      type: 'hidden',
      label: 'Password',
      placeholder: 'Password',
      onEnter: handleSubmit,
      theme: theme.textFieldTheme,
    }

    const formTheme: IFormTheme = {
      error: theme.error,
    }

    return (
      <Form onSubmit={handleSubmit} error={error} theme={formTheme}>
        <Field name='firstName' component={TextField} props={firstNameProps}/>
        <Field name='lastName' component={TextField} props={lastNameProps}/>
        <Field name='npi' component={TextField} props={npiProps}/>
        <Field name='confirmNpi' component={TextField} props={confirmNpiProps}/>
        <Field name='email' component={TextField} props={emailProps}/>
        <Field name='password' component={TextField} type="hidden" props={passwordProps}/>
        <Button
          className={classNames.button}
          icon='check'
          disabled={pristine || submitting}
          raised primary
          onClick={handleSubmit}
        >
        </Button>
      </Form>
    )
  }
}

export default RegisterForm

/**
 * Component factory for creating forms, intended for use with redux-form.
 *
 * @param formName key to where your form's state will be mounted under the redux-form reducer
 * @param onSubmit fn called when prop `handleSubmit` is fired
 */
export const registerFormFactory = (
  {
    formName,
    onSubmit,
  }: {
    formName: string,
    onSubmit: SubmitHandler<IFormFields, {}, {}>,
  },
) => {
  const initialValues: IFormFields = {
    firstName: '',
    lastName: '',
    npi: '',
    confirmNpi: '',
    email: '',
    password: generatePassword(),
  }

  const formDecorator = reduxForm<IFormFields, {}, {}>({
    form: formName,
    initialValues,
    onSubmit,
    validate: createValidator({
      firstName: [required],
      lastName: [required],
      npi: [required, integer, npiValidator(10)],
      confirmNpi: [required, integer, npiValidator(10), match<IFormFields>('npi', 'NPI')],
      email: [required, email],
      password: [required, minLength(8)],
    }),
  })

  return formDecorator(RegisterForm)
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/register/RegisterForm.tsx